import React from 'react';
import { useTranslation } from 'react-i18next';
import Scrollable from '../../components/scrollable/Scrollable';
import useReleaseNotes from './api/useReleaseNotes';
import ReleaseNoteList from './ReleaseNoteList';

const ReleaseNotes = () => {
  const { t } = useTranslation('agisviewer');
  const { data, isLoading } = useReleaseNotes();

  if (isLoading || !data?.length) return null;

  const [lastversion, ...versions] = data;

  return (
    <Scrollable>
      <ReleaseNoteList title={t('help_last_version')} items={[lastversion]} />
      <ReleaseNoteList title={t('help_previous_versions')} items={versions} />
    </Scrollable>
  );
};

export default ReleaseNotes;
